import axios from 'axios'
import Cookies from 'js-cookie'
import Vue from 'vue'
import VueResource from 'vue-resource'
import store from './store/store'
import { getWithDotNotation } from './utils'
import VueTheMask from 'vue-the-mask'

const backUrl = window.location.hostname.includes('localhost') ? 'localhost:5000' : 'back.pontotel.com.br'
const apiUrl = window.location.hostname.includes('localhost') ? 'localhost:8000' : 'paper.pontotel.com.br'

function safeHttp () {
  return window.location.hostname.includes('localhost') ? 'http://' : 'https://'
}

function parseUrlParams (params) {
  for (let [k, v] of Object.entries(params)) {
    if (Array.isArray(v)) {
      params[k] = '["' + v.join('","') + '"]'
    }
  }
  return params
}

function headers () {
  return {
    'CompMan': Cookies.get('CompMan') || Cookies.get('comp_man')
  }
}

Vue.use(VueResource)
Vue.http.interceptors.push(function (request, next) {
  request.headers.set('Authorization', Cookies.get('Authorization'))
  next()
})
export const API = {
  dayJourney: Vue.resource('https://' + backUrl + '/api/dayjourney{/id}'),
  journey: Vue.resource('https://' + backUrl + '/api/journey{/id}'),
  employee: Vue.resource('https://' + backUrl + '/api/employee{/id}'),
  company: Vue.resource('https://' + backUrl + '/api/company{/id}'),
  userGroups: Vue.resource('https://' + backUrl + '/api/user-group{/id}'),
  partialTimesheet: Vue.resource('https://' + backUrl + '/api/timesheet-partial-generic'),
  changeMultipleDayjourney: Vue.resource('https://' + backUrl + '/api/change-multiple-dayjourney'),
  timesheetSync: Vue.resource('https://' + backUrl + '/api/timesheet-partial-sync')
}
Vue.prototype.$API = API

export const mixins = {
  methods: {
    $getterUseState: (useState) => getWithDotNotation(store.state, useState, '/'),
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}
Vue.mixin(mixins)

Vue.use(VueTheMask)

export const handleRequest = {
  async post (endpoint, data) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    return axios.post('https://' + backUrl + '/api/' + endpoint, data)
  },
  async get (endpoint, data, params) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    if (params) {
      return axios.request({
        url: 'https://' + backUrl + '/api/' + endpoint,
        method: 'get',
        params: parseUrlParams(params),
        headers: headers(),
        timeout: 3000
      })
    } else if (data) {
      return axios.request({url: 'https://' + backUrl + '/api/' + endpoint, data, timeout: 3000})
    } else {
      return axios.request({url: 'https://' + backUrl + '/api/' + endpoint, timeout: 3000})
    }
  },
  async api (endpoint, data, params) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    axios.defaults.headers.common['UserId'] = Cookies.get('UserId')
    if (params) {
      return axios.request({
        url: safeHttp() + apiUrl + '/api/v1/' + endpoint,
        params: parseUrlParams(params),
        headers: headers()
      })
    } else if (data) {
      return axios.request({url: safeHttp() + apiUrl + '/api/v1/' + endpoint, data, method: 'put', headers: headers()})
    } else {
      return axios.request({url: safeHttp() + apiUrl + '/api/v1/' + endpoint, headers: headers()})
    }
  },
  async apiPost (endpoint, data) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    axios.defaults.headers.common['UserId'] = Cookies.get('UserId')
    return axios.request({url: safeHttp() + apiUrl + '/api/v1/' + endpoint, data, method: 'post', headers: headers()})
  },
  async digits (params) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    axios.defaults.headers.common['UserId'] = Cookies.get('UserId')
    return axios.request({url: safeHttp() + apiUrl + '/digits/' + params.uuid, headers: headers()})
  },
  async statusSheets (data) {
    return axios.request({url: safeHttp() + apiUrl + '/status-sheets', headers: headers(), method: 'post', data})
  },
  async autoFill (data) {
    return axios.request({url: safeHttp() + apiUrl + `/sheet-auto-fill/${data.id}`, headers: headers(), method: 'post', data})
  },
  sendDigit (param, data) {
    axios.defaults.headers.common['Authorization'] = Cookies.get('Authorization')
    axios.defaults.headers.common['UserId'] = Cookies.get('UserId')
    return axios.request({
      url: safeHttp() + apiUrl + '/api/v1/digit/' + param,
      data,
      method: 'post',
      headers: headers(),
      timeout: 5000
    })
  }
}



// WEBPACK FOOTER //
// ./src/services.js